import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { FormikErrors } from 'formik';

import { useStyles } from '../Themable.hooks';

import { DictionaryWrapper } from './DictionaryWrapper';
import { IAttributesForm } from './AttributesForm';
import { ObjectsTable } from './ObjectsTable';
import { CustomToggleButtonGroup } from '../../../../../components/Styled/StyledToggleButtonGroup';
import ToggleButtonWithError from '../../../../../components/ToggleButtonWithError';
import { TAttributeType } from '../../../../../features/Attributes/types';
import { ATTRIBUTE_TYPES } from '../../../../../features/Attributes/constants';

interface IOwnProps {
    values: IAttributesForm;
    errors: FormikErrors<IAttributesForm>;
    editMode: boolean;
    setFieldValue: (name: string, value: any) => void;
    isRegexDisabled: (type: TAttributeType) => boolean;
}

const DICTIONARY_TYPES = ['Integer', 'String', 'Double'];
export const BottomForm = ({
    values,
    setFieldValue,
    errors,
    editMode,
    isRegexDisabled,
}: IOwnProps) => {
    const initialTab = 'objects';
    const [alignment, setAlignment] = useState(initialTab);
    const [showDictionary, setShowDictionary] = useState(true);

    const classes = useStyles();

    useEffect(() => {
        if (!DICTIONARY_TYPES.includes(ATTRIBUTE_TYPES[values.type])) {
            setShowDictionary(false);
            setAlignment(initialTab);
        } else {
            setShowDictionary(true);
        }
        if (values.regex && isRegexDisabled(values.type)) {
            setFieldValue('regex', '');
        }
    }, [values.type]);

    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newAlignment: string
    ) => {
        if (newAlignment !== null) {
            setAlignment(newAlignment);
        }
    };
    return (
        <>
            <CustomToggleButtonGroup
                value={alignment}
                exclusive
                onChange={handleChange}
                aria-label="Platform"
                fullWidth
                size="medium"
                disabled={!showDictionary}
            >
                <ToggleButtonWithError
                    value="objects"
                    labelKey="Objects"
                    hasError={false}
                />
                <ToggleButtonWithError
                    value="dictionary"
                    labelKey="Dictionary"
                    hasError={!isEmpty(errors.dictionary)}
                    disabled={editMode && !values.dictionary.length}
                />
            </CustomToggleButtonGroup>
            {alignment === 'objects' && (
                <ObjectsTable
                    errors={errors}
                    values={values}
                    setFieldValue={setFieldValue}
                />
            )}
            {alignment === 'dictionary' && showDictionary && (
                <>
                    <DictionaryWrapper
                        formValues={values}
                        handleFormChange={(name, val) => {
                            setFieldValue(name, val);
                        }}
                        errors={errors}
                        classes={{ field: classes.fieldMulti }}
                        inputType={ATTRIBUTE_TYPES[values.type]}
                        editMode={editMode}
                    />
                </>
            )}
        </>
    );
};
